/* unplugin-vue-components disabled */import script from "./AddControlSalesTeamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddControlSalesTeamModal.vue?vue&type=script&setup=true&lang=js"

import "./AddControlSalesTeamModal.vue?vue&type=style&index=0&id=1d3eead0&lang=scss"

const __exports__ = script;

export default __exports__